import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SearchService } from 'src/app/Search/search.service';
import { QuickCriteria, QuickCriteriaFilter, QuickResultType } from '../quickCriteria.model';
import { QuickFiltersService } from '../quickFilters.service';

@Component({
    selector: 'quick-search-criteria-panel',
    templateUrl: './quickSearchCriteriaPanel.component.html',
    standalone: false,
})
export class QuickSearchCriteriaPanelComponent implements OnInit, OnDestroy {
    constructor(
        private readonly _searchService: SearchService,
        private readonly _quickFiltersService: QuickFiltersService,
    ) {}

    @Input() criteria: QuickCriteria;
    @Input() navigatingFrom: string;
    @Input() isOpen: boolean;

    @Output() criteriaChange: EventEmitter<QuickCriteria> = new EventEmitter();

    resultTypes: QuickResultType[];

    private _destroy$: Subject<void> = new Subject();

    ngOnInit(): void {
        // this._appStateService.appState$.subscribe((state) => {
        //     if (state === this._appStateService.appStates.LoggedIn) {
        //         this._statesService.getSummary().then((result) => {
        //             result.unshift({
        //                 label: ''
        //             });
        //             scope.vm.states = result;
        //         });
        //     }
        // });
        //
        // this._propertyTypeService.get().then((result) => {
        //     result.unshift({
        //         propertyTypeID: '',
        //         propTypeAbbr: ''
        //     });
        //     scope.vm.propertyTypes = result;
        // });
        this.resultTypes = this._searchService.getResultTypes();

        this._searchService.registerReset(this.resetCriteria.bind(this));

        this._searchService.getSitesForCompany$.pipe(takeUntil(this._destroy$)).subscribe((values) => {
            const { state, company, activeOnly, includeSubsidiaryFlag } = values;
            const stateField = 'siteStateAbbr';
            const companyField = 'companyName';
            const companyIDField = 'companyID';

            // hardcoded set
            const allFilters = this._quickFiltersService.getAll();

            // get companyName and stateAbbr filters
            const stateFilter = allFilters.find((x) => x.field === stateField);
            const companyFilter = allFilters.find((x) => x.field === companyField);
            const companyIDFilter = allFilters.find((x) => x.field === companyIDField);

            const query = {
                activeOnly: activeOnly,
                primaryAcctNumOnly: false,
                pageNumber: 1,
                pageSize: 30,
                resultType: 'site',
                resultsAs: { id: 5 },
                siteStateAbbr: state,
                excludeSubsidiarySites: !includeSubsidiaryFlag,
                activeFilters: [companyFilter, stateFilter],
            };

            // get default criteria, add (or assign value to) companyName and stateAbbr elements
            this.criteria = this._searchService.getCriteria();

            // set the result type to 'site'
            this.criteria.resultType = query.resultType;

            this._addOrUpdateFilter(stateField, stateFilter, state);
            this._addOrUpdateFilter(companyField, companyFilter, company.companyName);
            this._addOrUpdateFilter(companyIDField, companyIDFilter, `${company.companyID}`);

            this.criteria.activeOnly = activeOnly;
            this.criteria.primaryAcctNumOnly = false;
            this.criteria.excludeSubsidiarySites = !includeSubsidiaryFlag;

            // set criteria and trigger the search
            this._searchService.setCriteria(this.criteria, true);
        });
    }

    ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }

    resetCriteria(): void {
        this.clearForm();
    }

    clearForm(): void {
        this._searchService.loadSavedCriteria(); // ToDo: Move this to activate once we are no longer loading search on initial app load.

        this._searchService.resetCriteria();
        this.resultTypes = this._searchService.getResultTypes();
        this.criteria = this._searchService.getCriteria();
    }

    search(): void {
        this._searchService.setCriteria(this.criteria, true);
    }

    criteriaChanged(criteria: QuickCriteria): void {
        this.criteria = criteria;
        this.criteriaChange.emit(this.criteria);
    }

    private _addOrUpdateFilter(fieldName: string, filter: QuickCriteriaFilter, filterTextValue: string): void {
        // check if these filters have been added or not
        filter.text = filterTextValue;
        const idx = this.criteria.activeFilters.findIndex((x) => x.field === fieldName);

        // Handle filter
        if (idx >= 0) {
            this.criteria.activeFilters[idx] = filter;
        } else {
            this.criteria.activeFilters.push(filter);
            const i = this.criteria.inactiveFilters.findIndex((x) => x.field === fieldName);
            this.criteria.inactiveFilters.splice(i, 1);
        }
    }
}
